module.exports = __webpack_public_path__ + "fonts/element-icons.2fad952a.woff";